import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryRemarks from "../components/EntryRemarks";
import EntryGridAr from "../components/EntryGridAr";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import GridPanelControl from "../components/GridPanelControl";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, initializedata, Getstorage, Savestorage, NumConv, DeepCopy, isEnabled,
    getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, Round, DicVal, RandomKey, isNumber
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, reports, gridmaximize, setgridlist } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const Pattern = props => {
    const GridPanelStorageKey = "Pattern_GridPanel";   //GridPanel最大化フラグ保存キー

    const G_id = {
        BASE: "0", SIZE: "1", SIZEDTL: "2", SIZECALC: "3", SPEC1: "10", SPEC2: "11", SPEC3: "12", SPEC4: "13", SPEC5: "14",
        SPEC6: "15", SPEC7: "16", SPEC8: "17", SPEC9: "18", SPEC10: "19",NB: "nb", IMAGE: "pic", FILE: "file"
    }
    const panelsdef = [];

    const primarykeys = ["d_ptn_code", "d_ptn_size_key", "d_ptn_sizeitem_key", "d_ptn_sizedtl_key", "d_ptn_spec_key"];
    const formid = getformid("Pattern", props.location.search);
    const controller = getcontroller("Pattern", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [rowmode, setrowmode] = useState(0);      //0:寸法表 1:グレーディング
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const reportsRef = useRef(null);
    const GridPanelRef = useRef(null);      //最大化状態

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);    
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  


    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function GridColDef(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolRefs.current[gidx].current;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    const actionurl = {
        "insert": "pattern/Insert",
        "update": "pattern/Update",
        "delete": "pattern/Delete",
        "saveas": "pattern/SaveAs",
        "storageadd": "pattern/AddStorage",
        "storagerowdel": "pattern/StorageRowdel",
        "upload": "pattern/Upload",
        "imageadd":"pattern/AddImage",
        "masonry": "pattern/Masonry",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "formupload2", icon: "upload_file", label: "画像/資料マスタのファイルを追加", title: "画像/資料マスタのファイルを追加します" },
        { status: "ENTRY FORM", menuid: "sep1" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep3" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "upload2", icon: "upload_file", label: "画像/資料マスタのファイルを追加", title: "画像/資料マスタのファイルを追加します" },
        { status: "VIEW", menuid: "sep4" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }

    function onDragEnter(e){
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;

                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    let gridmaxinit = {};
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        gridmaxinit[fnc.current.GridID(panel)] = false;
                        idx++;
                    });
                    dispatch(setgridlist(glist));

                    //パネル最大化Flag
                    var gridmax = Getstorage(corpkey, account, GridPanelStorageKey);    //保存データ
                    if (isEmpty(gridmax)) {
                        gridmax = gridmaxinit;
                    }
                    GridPanelRef.current = gridmax
                    dispatch(gridmaximize(gridmax));
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_ptn_code"] = "";
            entrydataRef.current["d_ptn_createac"] = "";
            entrydataRef.current["d_ptn_createdate"] = "";
            entrydataRef.current["d_ptn_updateac"] = "";
            entrydataRef.current["d_ptn_update"] = "";
            rerender();
       }
    }, [formstatus]);


    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    if (gridlist[i].id === G_id.SIZEDTL || gridlist[i].id === G_id.SIZECALC) continue;
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function onGridReady(param, panel) {
        if (panel.id === G_id.SIZEDTL || panel.id === G_id.SIZECALC) {
            SetGridApi(panel, param.api);
            SetGridColApi(panel, param.api);
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('pattern/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_ptn_memo" in row) data.data.d_ptn_memo = row.d_ptn_memo;
                                if ("d_ptn_sticky" in row) data.data.d_ptn_sticky = row.d_ptn_sticky;
                                if ("d_ptn_mytags" in row) data.data.d_ptn_mytags = row.d_ptn_mytags;
                            }
                        }
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = data.data;
                        //行データ
                        SetGridData({ id: G_id.SIZE }, data.size.length === 0 ? null : data.size);
                        SetGridData({ id: G_id.SPEC1 }, data.spec1.length === 0 ? null : data.spec1);
                        SetGridData({ id: G_id.SPEC2 }, data.spec1.length === 0 ? null : data.spec2);
                        SetGridData({ id: G_id.SPEC3 }, data.spec1.length === 0 ? null : data.spec3);
                        SetGridData({ id: G_id.SPEC4 }, data.spec1.length === 0 ? null : data.spec4);
                        SetGridData({ id: G_id.SPEC5 }, data.spec1.length === 0 ? null : data.spec5);
                        SetGridData({ id: G_id.SPEC6 }, data.spec1.length === 0 ? null : data.spec6);
                        SetGridData({ id: G_id.SPEC7 }, data.spec1.length === 0 ? null : data.spec7);
                        SetGridData({ id: G_id.SPEC8 }, data.spec1.length === 0 ? null : data.spec8);
                        SetGridData({ id: G_id.SPEC9 }, data.spec1.length === 0 ? null : data.spec9);
                        SetGridData({ id: G_id.SPEC10 }, data.spec1.length === 0 ? null : data.spec10);
                        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                            //PL行データ
                            SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                        });

                        imageRef.current = data.images;
                        fileRef.current = data.files;
                        dispatch(setimagelist(data.images));

                        if (data.size.length !== 0) {
                            if (DicVal(data.data, 'd_ptn_type', '0') === '0') {
                                //寸法表
                                CreateSizeTable(data.size, data.sizedtl);               
                            } else {
                                //グレーディング
                                CreateGradingTable(true, data.size, data.sizedtl);
                            }
                        }

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
               },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function MenuQueryAction(action, param) {
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSavestorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            var type = finallycallback.type;
            if (isEmpty(finallycallback.type)) {
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col === undefined) return;
                type = col.type;
            }
            if (finallycallback.table == "d_ptn") {
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    let key = finallycallback.field + "_" + finallycallback.type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
                return;
            }
            let col = columninfo.find(e => e.type === type);
            if (col === undefined) return;
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('pattern/GetDataTree', { "controller": controller, "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Save(finallycallback) {
        if (DicVal(entrydataRef.current,'d_ptn_type',"") === '1') {
            //グレーディングチェック
            if (!CreateGradingTable(false)) {
                return;
            }
        }
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        SetPLData();    //PL行データをentrydataRefにセット
        const paramdata = {
            "controller": controller,
            "data": entrydataRef.current,
            "size": EmptyPanel(G_id.SIZE) ? null : GridData(G_id.SIZE),
            "sizedtl": EmptyPanel(G_id.SIZEDTL) ? null : (DicVal(entrydataRef.current,'d_ptn_type',"") === '1'?GridData(G_id.SIZECALC):GridData(G_id.SIZEDTL)),
            "spec1": EmptyPanel(G_id.SPEC1) ? null : GridData(G_id.SPEC1),
            "spec2": EmptyPanel(G_id.SPEC2) ? null : GridData(G_id.SPEC2),
            "spec3": EmptyPanel(G_id.SPEC3) ? null : GridData(G_id.SPEC3),
            "spec4": EmptyPanel(G_id.SPEC4) ? null : GridData(G_id.SPEC4),
            "spec5": EmptyPanel(G_id.SPEC5) ? null : GridData(G_id.SPEC5),
            "spec6": EmptyPanel(G_id.SPEC6) ? null : GridData(G_id.SPEC6),
            "spec7": EmptyPanel(G_id.SPEC7) ? null : GridData(G_id.SPEC7),
            "spec8": EmptyPanel(G_id.SPEC8) ? null : GridData(G_id.SPEC8),
            "spec9": EmptyPanel(G_id.SPEC9) ? null : GridData(G_id.SPEC9),
            "spec10": EmptyPanel(G_id.SPEC10) ? null : GridData(G_id.SPEC10),
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode
        }

        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "pattern/UpdateEntry" : "pattern/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            entrydataRef.current["m_ptn_code"] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("pattern", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("pattern/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        imageRef.current = null;
        fileRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        if (!isEmpty(GridColDef(G_id.SIZEDTL)) && !isEmpty(GridApi(G_id.SIZEDTL))) {
            let coldef = GridColDef(G_id.SIZEDTL).filter(e => !isEnabled(DicVal(e.colinfo, 'expansion', false)));    //サイズ項目除外
            SetGridColDef(G_id.SIZEDTL, coldef);
            GridApi(G_id.SIZEDTL).setGridOption('columnDefs', coldef);
        }
        if (!isEmpty(GridColDef(G_id.SIZECALC)) && !isEmpty(GridApi(G_id.SIZECALC))) {
            let coldef = GridColDef(G_id.SIZECALC).filter(e => !isEnabled(DicVal(e.colinfo, 'expansion', false)));    //サイズ項目除外
            SetGridColDef(G_id.SIZECALC, coldef);
            GridApi(G_id.SIZECALC).setGridOption('columnDefs',coldef);
        }

        setrowmode(0);
        scrollRef.current = null;
        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSavestorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }


    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
   }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        if (edit && id === 'd_ptn_type') {
            //種別が0,1以外の場合0を強制表示
            if (value !== '0' && value !== '1') {
                entrydataRef.current['d_ptn_type'] = '0';
            } else {
                entrydataRef.current['d_ptn_type'] = value;
            }
            if (entrydataRef.current['d_ptn_type'] === '0' && GridData(G_id.SIZEDTL) === null) {
                CreateSizeTable();
                entrydataRef.current['d_ptn_type'] = '0';
            }
            rerender();
            return;
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    function GridValueChanged(panel, params) {
        storeRowData(panel);
        SizeChange(panel.id === G_id.SIZE);
        if (panel.id === G_id.SIZECALC) {
            SizeCalcChange(params);
        }
    }
    function SizeCalcChange(params) {
        SetGridApi(G_id.SIZECALC, params.api);
        SetGridColApi(G_id.SIZECALC, params.columnApi);
        let rowidx = params.node.rowIndex;
        if (params.column.colId !== "d_ptn_sizedtl_pitch") {
            var set_f = false;
            if (isEmpty(GridData(G_id.SIZE))) return;
        } else {
            if (isEmpty(GridData(G_id.SIZE))) return;
            //共通ピッチを各サイズピッチに反映
            let master = false;
            let sizetype = DicVal(GridData(G_id.SIZE)[0],'d_ptn_size_type','');
            for (let i = 0; i < GridData(G_id.SIZE).length; i++) {
                let size = GridData(G_id.SIZE)[i];
                if (DicVal(size,'d_ptn_size_type','') !== sizetype) {
                    sizetype = DicVal(size,'d_ptn_size_type','');
                    master = false;
                }
                if (size['d_ptn_size_master'] !== "1") {
                    if (isEmpty(params.newValue)) {
                        GridData(G_id.SIZECALC)[rowidx][size['d_ptn_size_no']] = '';
                    } else {
                        let pitch = NumConv(params.newValue)
                        if (!master) pitch *= -1;
                        GridData(G_id.SIZECALC)[rowidx][size['d_ptn_size_no']] = pitch;
                    }
                } else {
                    master = true;
                }
            }
            var node = GridApi(G_id.SIZECALC).getDisplayedRowAtIndex(rowidx);
            if (!isEmpty(node)) {
                node.setData(GridData(G_id.SIZECALC)[rowidx]);
            }
        }
    }

    function SizeChange(mode) {
        if (!mode) return;  //処理不要
        if (DicVal(entrydataRef.current,'d_ptn_type',"") === '1') {
            //グレーディング
            CreateGradingTable(true)
        } else {
            //寸法表
            CreateSizeTable();
        }
        storeRowData(G_id.SIZE);
    }

    function sizecollection() {
        let size = [];
        GridApi(G_id.SIZE).forEachNode((rowNode, index) => {
            if (size.indexOf(rowNode.data.d_ptn_size_no) === -1) {
                if (!isEmpty(rowNode.data.d_ptn_size_no)) {
                    rowNode.data.d_ptn_size_no = rowNode.data.d_ptn_size_no.toString();    //Fillで作成された場合を考慮
                    size.push(rowNode.data);
                }
            }
        });
        return size;
    }
    //寸法表作成
    function CreateSizeTable(size, data) {
        if (EmptyPanel(G_id.SIZEDTL)) return;
        if (isEmpty(GridApi(G_id.SIZE))) return;
        if (isEmpty(size)) {
            size = sizecollection();
        }
        let coldef = GridColDef(G_id.SIZEDTL).filter(e => !isEnabled(DicVal(e.colinfo, 'expansion', false)));    //サイズ項目除外
        for (let i = 0; i < size.length; i++) {
            let col = {
                columnid: size[i]['d_ptn_size_no'],
                columnnm: size[i]['d_ptn_size_no'],
                datatype: "0", logpid: G_id.SIZEDTL, formula: '',  expansion: true
            }
            coldef.push({
                colId: size[i]['d_ptn_size_no'], field: size[i]['d_ptn_size_no'], headerName: size[i]['d_ptn_size_no'],
                width: 80, filter: false, sortable: false, resizable: true, menuTabs: ['generalMenuTab'],
                colinfo: col, editable: true,
                cellStyle: params => {
                    if (i !== 0) {
                        //体型の切り替わり
                        if (DicVal(size[i - 1],'d_ptn_size_type', '') !== DicVal(size[i],'d_ptn_size_type','')) {
                            return { 'border-left': '2px solid #aaa' };
                        }
                    }
                    return { 'border-left': 'none' };
                }
           });
        }
        SetGridColDef(G_id.SIZEDTL, coldef);

        if (size.length === 0) {
            GridApi(G_id.SIZE).setGridOption('rowData', []);
            SetGridData(G_id.SIZEDTL, null);
            return;
        }

        if (isEmpty(data)) {
            data = AGRef.current.GetDatasource(GridApi(G_id.SIZEDTL));
        }
        SetGridData(G_id.SIZEDTL, data);
    
        fnc.current.rerenderGrid(fnc.current.GridID(G_id.SIZEDTL));    //再描画
    }
    //グレーディング作成
    function CreateGradingTable(nocheck,size,data) {
        if (isEmpty(size)) {
            size = sizecollection();
        }
        if (size.length === 0 && !nocheck) {
            fnc.current.warnmsg("サイズを入力してください");
            return false;
        }
        let target = size.filter(e => e['d_ptn_size_master'] === "1");
        if (target.length === 0 && !nocheck) {
            fnc.current.warnmsg("基準サイズを指定してください");
            return false;
        }
        let sizetype = [];
        if (target.length > 1 && !nocheck) {
            //基準サイズに指定された体型を列挙
            for (let i = 0; i < target.length; i++) {
                if (sizetype.indexOf(DicVal(target[i],'d_ptn_size_type','')) !== -1) {
                    fnc.current.warnmsg("同一体型内に基準サイズが複数指定されています");
                    return false;
                }
                sizetype.push(DicVal(target[i],'d_ptn_size_type',''));
            }
        }
        let types = [];
        for (let i = 0; i < size.length; i++) {
            let item = DicVal(size[i],'d_ptn_size_type','');
            if (types.indexOf(item) === -1) {
                types.push(item);
            }
        }
        if (types.length > 1 && types.length !== sizetype.length && !nocheck) {
            fnc.current.warnmsg("基準サイズが指定されていない体型が存在します");
            return false;
        }

        let coldef = GridColDef(G_id.SIZECALC).filter(e => !isEnabled(DicVal(e.colinfo, 'expansion', false)));    //サイズ項目除外
        let fstsize = "";
        for (let i = 0; i < size.length; i++) {
            if (size[i]['d_ptn_size_master'] === '1') {
                if (fstsize.length === 0) fstsize = size[i]['d_ptn_size_no']
                let col = {
                    columnid: size[i]['d_ptn_size_no'],
                    columnnm: size[i]['d_ptn_size_no'],
                    datatype: "0", logpid: G_id.SIZECALC, formula: '', expansion: true
                }
                let row = {
                    colId: size[i]['d_ptn_size_no'], field: size[i]['d_ptn_size_no'], headerName: size[i]['d_ptn_size_no'],
                    width: 80, filter: false, sortable: false, resizable: true, menuTabs: ['generalMenuTab'],
                    colinfo: col, editable: true,
                    cellStyle: params => {
                        let color = fstsize === size[i]['d_ptn_size_no'] ? "#fafad2" : "#daf2d0";   //先頭体型とそれ以外
                        if (i !== 0) {  
                            //体型の切り替わり
                            if (DicVal(size[i - 1], 'd_ptn_size_type', '') !== DicVal(size[i], 'd_ptn_size_type', '')) {
                                return { color: 'black', 'background-color': color , 'border-left': '2px solid #aaa' };
                            }
                        }
                        return { color: 'black', 'background-color': color ,'border-left': 'none' };
                    }
                }
                coldef.push(row);
            } else {
                let col = {
                    columnid: size[i]['d_ptn_size_no'],
                    columnnm: size[i]['d_ptn_size_no'],
                    datatype: "1", logpid: G_id.SIZECALC, decimalplace: 2, formula: 'showzero', expansion: true
                }
                let row = {
                    colId: size[i]['d_ptn_size_no'], field: size[i]['d_ptn_size_no'], headerName: size[i]['d_ptn_size_no'],
                    width: 80, filter: false, sortable: false, resizable: true, menuTabs: ['generalMenuTab'],
                    cellClass: 'ag-right-aligned-cell', colinfo: col, editable: true,
                    cellStyle: params => {
                        if (i !== 0) {
                            //体型の切り替わり
                            if (DicVal(size[i - 1], 'd_ptn_size_type', '') !== DicVal(size[i], 'd_ptn_size_type', '')) {
                                return { 'border-left': '2px solid #aaa' };
                            }
                        }
                        return { color: 'black', 'background-color': null, 'border-left': 'none' };
                    }
                }
                coldef.push(row);
            }
        }
        SetGridColDef(G_id.SIZECALC, coldef);

        if (isEmpty(data)) {
            data = AGRef.current.GetDatasource(GridApi(G_id.SIZE));
            data = data.filter(e => !isEmpty(e['d_ptn_sizedtl_item']));
            if (data.length === 0) {
                if (isEmpty(GridData(G_id.SIZECALC)) || GridData(G_id.SIZECALC).length === 0) {
                    SetGridData(G_id.SIZECALC, [{ rowid: RandomKey() }]);
                }
            } else {
                let newdata = [];
                for (let i = 0; i < data.length; i++) {
                    if (isEmpty(GridData(G_id.SIZECALC))) SetGridData(G_id.SIZECAL, []);
                    let item = GridData(G_id.SIZECALC).find(e => e['d_ptn_sizedtl_item'] === data[i]['d_ptn_sizedtl_item']);
                    if (isEmpty(item)) {
                        newdata.push({ rowid: RandomKey(), 'd_ptn_sizedtl_item': data[i]['d_ptn_sizedtl_item'] });
                    } else {
                        newdata.push(item);
                    }
                }
                SetGridData(G_id.SIZECALC, newdata);
            }
        } else {
            SetGridData(G_id.SIZECALC, data);
        }

        fnc.current.rerenderGrid(fnc.current.GridID(G_id.SIZECALC));    //再描画
        return true;
    }

    //逆算
    function Reverse() {
        let data = GridData(G_id.SIZEDTL).filter(e => !isEmpty(e['d_ptn_sizedtl_item']));
        if (data.length === 0) {
            fnc.current.warnmsg("寸法表が入力されていません");
            return;
        }
        fnc.current.confmsg("寸法表からグレーディングピッチを算出します。よろしいですか？", () => exec());
        function exec() {
            let newdata = [];
            for (let i = 0; i < data.length; i++) {
                let row = { rowid: data[i].rowid, d_ptn_sizedtl_item: data[i]['d_ptn_sizedtl_item'] };
                let mastercnt = 0;
                let prebase = 0;
                for (let j = 0; j < GridData(G_id.SIZE).length; j++) {
                    let size = GridData(G_id.SIZE)[j];
                    if (size['d_ptn_size_master'] === "1") {
                        if (mastercnt === 0) {
                            row[size['d_ptn_size_no']] = data[i][size['d_ptn_size_no']];
                        } else {
                            row[size['d_ptn_size_no']] = Round(NumConv(data[i][size['d_ptn_size_no']]) - prebase,2); //体型グレーディング（前の基準からの差数）
                        }
                        var basevalue = NumConv(data[i][size['d_ptn_size_no']]);
                        if (basevalue !== 0) {
                            //基準寸法から各サイズのグレーディング値を計算
                            ReverseSizeTable(data[i], row, j, DicVal(size,'d_ptn_size_type',''), basevalue);
                        }
                        prebase = basevalue;
                        mastercnt++;
                    }
                }
                newdata.push(row);
            }
            SetGridData(G_id.SIZECALC, newdata);

            fnc.current.rerenderGrid(fnc.current.GridID(G_id.SIZECALC));    //再描画
        }
    }
    function ReverseSizeTable(data, row, idx, sizetype, basevalue) {
        var bv = basevalue;
        for (let i = idx - 1; i >= 0; i--) {
            let size = GridData(G_id.SIZE)[i];
            if (DicVal(size,'d_ptn_size_type','') !== sizetype) break;
            if (isEmpty(data[size['d_ptn_size_no']])) break;
            if (data[size['d_ptn_size_no']] === '←') {
                row[size['d_ptn_size_no']] = 0
                continue;
            }
            let value = NumConv(data[size['d_ptn_size_no']]);
            row[size['d_ptn_size_no']] = Round(value - bv,2);
            bv = value;
        }
        bv = basevalue;
        for (let i = idx + 1; i < GridData(G_id.SIZE).length; i++) {
            let size = GridData(G_id.SIZE)[i];
            if (DicVal(size,'d_ptn_size_type','') !== sizetype) break;
            if (isEmpty(data[size['d_ptn_size_no']])) break;
            if (data[size['d_ptn_size_no']] === '→') {
                row[size['d_ptn_size_no']] = 0
                continue;
            }
            let value = NumConv(data[size['d_ptn_size_no']]);
            row[size['d_ptn_size_no']] = Round(value - bv,2);
            bv = value;
        }
    }

    //計算実行
    function Calculate() {
        storeRowData(G_id.SIZECALC);
        let data = GridData(G_id.SIZECALC).filter(e => !isEmpty(e['d_ptn_sizedtl_item']));
        if (data.length === 0) {
            fnc.current.warnmsg("グレーディングデータが入力されていません");
            return;
        }
        let newdata = [];
        for (let i = 0; i < data.length; i++) {
            let row = { rowid: data[i].rowid, d_ptn_sizedtl_item: data[i]['d_ptn_sizedtl_item'] };
            let prevalue = 0;
            let basesize = '';
            for (let j = 0; j < GridData(G_id.SIZE).length; j++) {
                let size = GridData(G_id.SIZE)[j];
                if (size['d_ptn_size_master'] === "1") {
                    var basevalue = Round(NumConv(data[i][size['d_ptn_size_no']]) + prevalue, 1);
                    if (basesize === '') {    //最初の基準値
                        row[size['d_ptn_size_no']] = data[i][size['d_ptn_size_no']];
                        basesize = data[i][size['d_ptn_size_no']]
                    }
                    else {
                        //最初の基準値が数値の場合計算値をセット
                        if (!isNaN(basesize)) row[size['d_ptn_size_no']] = basevalue;
                        else basevalue = 0;
                    }
                    if (basevalue !== 0) {
                        //基準寸法から各サイズの寸法値を計算
                        CalcSizeTable(data[i], row, j, DicVal(size,'d_ptn_size_type',''), basevalue);
                    }
                    prevalue = basevalue;
                }
            }
            newdata.push(row);
        }
        SetGridData(G_id.SIZEDTL, newdata);
        fnc.current.rerenderGrid(fnc.current.GridID(G_id.SIZEDTL));    //再描画

        rowmodeChange();
    }
    function CalcSizeTable(data, row, idx, sizetype, basevalue) {
        var bv = basevalue;
        for (let i = idx - 1; i >= 0; i--) {
            let size = GridData(G_id.SIZE)[i];
            if (DicVal(size,'d_ptn_size_type','') !== sizetype) break;
            if (isEmpty(data[size['d_ptn_size_no']])) break;
            let value = NumConv(data[size['d_ptn_size_no']]);
            if (value === 0) {
                row[size['d_ptn_size_no']] = '←';
            } else {
                bv += value;
                row[size['d_ptn_size_no']] = Round(bv,2);
            }
        }
        bv = basevalue;
        for (let i = idx + 1; i < GridData(G_id.SIZE).length; i++) {
            let size = GridData(G_id.SIZE)[i];
            if (DicVal(size,'d_ptn_size_type','') !== sizetype) break;
            if (isEmpty(data[size['d_ptn_size_no']])) break;
            let value = NumConv(data[size['d_ptn_size_no']]);
            if (value === 0) {
                row[size['d_ptn_size_no']] = '→';
            } else {
                bv += value;
                row[size['d_ptn_size_no']] = Round(bv,2);
            }
        }
    }

    function rowmodeChange() {
        if (rowmode === 0) {    //寸法表→グレーディング
            storeRowData(G_id.SIZEDTL);
            let ret = CreateGradingTable(false);
            if (ret) setrowmode(1);
        } else {                //グレーディング→寸法表
            setrowmode(0);
        }
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            if (props.panel.id !== G_id.PL) {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onGridReady={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={(e) => GridValueChanged(props.panel,e)}
                        RowValueChanged={()=>SizeChange(props.panel.id===G_id.SIZE)}
                        RemoveRow={() => SizeChange(props.panel.id === G_id.SIZE)}
                        SwapRow={() => SizeChange(props.panel.id === G_id.SIZE)}
                        panel={props.panel}
                        EntrybodyRef={EntrybodyRef}
                  />
                );
            } else {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={() => storeRowData(props.panel)}
                        panel={props.panel}
                        EntrybodyRef={EntrybodyRef}
                    />
                );
            }
        }
        if (props.panel.id === G_id.FILE) {
            //v1.4
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            let coldef = null;
            if (!isEmpty(columninfo)) {
                coldef = columninfo.find(e => e.type === props.panel.type);
            }
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE)  return isEmpty(textfields.find(e => e.type === type));
            if (id === G_id.NB) return isEmpty(columninfo.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (DicVal(entrydataRef.current,'d_ptn_type',"") === '1') {
            if (p.id === G_id.SIZEDTL) return true;     //グレーディグの場合寸法表非表示
        } else {
            if (rowmode === 0 && p.id === G_id.SIZECALC) return true;
            if (rowmode === 1) {
                if (p.id !== G_id.BASE && p.id !== G_id.SIZECALC) return true;
                if (p.id === G_id.BASE && p.type !== '100') return true;
            }
        }

        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function maximizeChanged(id, max) {
        const newvalue = JSON.parse(JSON.stringify(GridPanelRef.current));
        newvalue[id] = max;
        GridPanelRef.current = newvalue;
        //ストレージに保存
        Savestorage(corpkey, account, GridPanelStorageKey, GridPanelRef.current);
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom:'300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {p.id !== G_id.SIZEDTL ? null :
                                       <React.Fragment>
                                            <div style={{ position: 'absolute', right: 100, top: -3 }}>
                                                <Button size="small" endIcon={<Icon style={{ fontSize: 16 }}>arrow_forward</Icon>} onClick={rowmodeChange}>
                                                   グレーディング 
                                                </Button>
                                            </div>
                                       </React.Fragment>
                                   }
                                   {!(p.id === G_id.SIZECALC && DicVal(entrydataRef.current,'d_ptn_type',"") !== '1')  ? null:
                                       <div style={{ position: 'absolute', right: 100, top: -8 }}>
                                           <Button size="small" onClick={Reverse} title={"寸法表からグレーディングピッチを算出"}
                                               style={{
                                                   width: 120, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight:50
                                               }}
                                           >
                                               逆算実行
                                           </Button>
                                           <Button size="small" onClick={Calculate}
                                               style={{
                                                   width: 120, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700
                                               }}
                                           >
                                               計算実行
                                           </Button>
                                           <Button size="small" onClick={rowmodeChange}
                                               style={{
                                                   width: 120, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginLeft:5
                                               }}
                                           >
                                               中止
                                           </Button>
                                       </div>
                                   }
                                   {NumConv(p.id) === 0 ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }}>
                                           <GridPanelControl id={fnc.current.GridID(p)} fnc={fnc} gridmaximize={GridPanelRef} ValueChanged={maximizeChanged} />
                                       </div>
                                   }
                                   {layoutlock || sectionclose || p.id === G_id.SIZECALC ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                               </div>
                               <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_ptn'}
                primarykey={primarykeys}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload' && e.menuid !== 'formupload2'):navmenu}
                masonry={true}
                lockcell={ListlockCell}
            >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={()=>fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210}}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.2,
                            m: 0,
                        }}
                        component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};

